import axios from "axios";
import { authHeaders } from "./nodeAuthService";
import { API_BASE_URL } from "../config/api";

const BASE_URL = `${API_BASE_URL}/api/payment-logs`;

/** Drop empty filter values; join arrays (stage/action multi-selects) as comma-separated. */
function cleanParams(params = {}) {
  const out = {};
  Object.entries(params).forEach(([k, v]) => {
    if (Array.isArray(v)) {
      if (v.length) out[k] = v.join(",");
    } else if (v !== undefined && v !== null && v !== "") {
      out[k] = v;
    }
  });
  return out;
}

/** GET /api/payment-logs → { items, total, page, limit } */
export async function getPaymentLogs(params = {}) {
  const { data } = await axios.get(BASE_URL, {
    headers: authHeaders(),
    params: cleanParams(params),
  });
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    total: Number(data?.total) || 0,
    page: Number(data?.page) || 1,
    limit: Number(data?.limit) || 25,
  };
}

/** GET /api/payment-logs/assign-vendor/:id → entries, oldest first. */
export async function getAssignVendorTimeline(id) {
  const { data } = await axios.get(
    `${BASE_URL}/assign-vendor/${encodeURIComponent(id)}`,
    { headers: authHeaders() },
  );
  return Array.isArray(data?.items) ? data.items : [];
}

/** GET /api/payment-logs/export — downloads an .xlsx for the current filters. */
export async function exportPaymentLogs(params = {}) {
  const { data, headers } = await axios.get(`${BASE_URL}/export`, {
    headers: authHeaders(),
    params: cleanParams(params),
    responseType: "blob",
  });
  const disposition = headers?.["content-disposition"] || "";
  const match = disposition.match(/filename="?([^";]+)"?/i);
  const filename = match ? match[1] : "payment-log.xlsx";
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
